export const dexpara_ordem = ['dexpara.ordem']
export const dexpara_resultado = ['dexpara.resultado']
export const dexpara_material = ['dexpara.material']
export const dexpara_complement = ['dexpara.complement']
export const dexpara_metodo = ['dexpara.metodo']
export const dexpara_exame_resultado = ['dexpara.exame.resultado']
export const dexpara_tipo = ['dexpara.tipo']

// CRUD
export const tipo = ['tipo']
export const tipo_create = ['tipo.create']
export const tipo_edit = ['tipo.edit']
export const tipo_value_create = ['tipo.value.create']
export const tipo_value_edit = ['tipo.value.edit']

// CRUD result range
export const result_range = ['resultrange']
export const result_range_create = ['resultrange.create']
export const result_range_edit = ['resultrange.edit']

// CRUD result conversion
export const result_conversion = ['resultconversion']
export const result_conversion_create = ['resultconversion.create']
export const result_conversion_edit = ['resultconversion.edit']

export default [].concat(
    dexpara_ordem,
    dexpara_resultado,
    dexpara_material,
    dexpara_complement,
    dexpara_metodo,
    dexpara_exame_resultado,
    dexpara_tipo,

    // CRUD
    tipo,
    tipo_create,
    tipo_edit,
    tipo_value_create,
    tipo_value_edit,

    // CRUD result range
    result_range,
    result_range_create,
    result_range_edit,

    // CRUD result conversion
    result_conversion,
    result_conversion_create,
    result_conversion_edit,
)
